"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPrintPreview(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm3.5 2.625h-.875v-1.75a.82666.82666 0 0 1 .875-.875h7a.82666.82666 0 0 1 .875.875v1.75h-.875v-1.75h-7zm.875 7h3.97424a5.38751 5.38751 0 0 1 1.08051-.875h-5.05475zm0 .875v.875h2.81549a6.56929 6.56929 0 0 1 .47751-.875zm3.68121 3.5h-4.55621a.82669.82669 0 0 1 -.875-.875v-2.625h-1.75a.82669.82669 0 0 1 -.875-.875v-5.25a.82666.82666 0 0 1 .875-.875h12.25a.82666.82666 0 0 1 .875.875v4.07062a4.74754 4.74754 0 0 0 -3.5-.20514v-.36548h-7v5.25h3.9469a6.33965 6.33965 0 0 0 .60931.875zm3.31879-8.75a.875.875 0 0 0 1.75 0 .875.875 0 0 0 -1.75 0zm.625 3.75a4.42471 4.42471 0 0 1 4 2.99432 5.062 5.062 0 0 1 -2.05 2.45534c-2.2 1.3175-4.85.17965-5.95-2.45534a4.42471 4.42471 0 0 1 4-2.99432m1.95 1.557c0 .23955.05.47909.05.77853a2.23133 2.23133 0 0 1 -2 2.39547 2.23133 2.23133 0 0 1 -2-2.39545 2.23631 2.23631 0 0 1 .15-.83841c-.05 0-.05.05988-.1.05988a3.86157 3.86157 0 0 0 -1.2 1.43728 3.788 3.788 0 0 0 1.25 1.3774 3.00494 3.00494 0 0 0 3.9 0 4.70228 4.70228 0 0 0 1.15-1.37738 3.86157 3.86157 0 0 0 -1.2-1.43728m-1.95.47909a.817.817 0 0 0 -.75-.89829.913.913 0 0 0 0 1.79659.8557.8557 0 0 0 .75-.8983' })));
}
exports.default = SvgPrintPreview;
